import { head, includes, isEmpty, split } from 'ramda';
import { createAction, handleActions } from 'redux-actions';

import { appendMode } from 'constants/general';
import fetch from 'features/common/fetch';
import { appUser, configJSON } from 'features/common/fetch/beEndpoints';

export const emptyObj = {};

export const emptyArr = [];

export const createStandardTableReducer = (name, initialState = []) => {
	const caps = name.toUpperCase();

	const actionTypes = {
		SET_TABLE_DATA: `${caps}_SET_TABLE_DATA`,
		APPEND_TABLE_DATA: `${caps}_APPEND_TABLE_DATA`,
		RESET_TABLE_DATA: `${caps}_RESET_TABLE_DATA`,
	};

	const actions = {
		setData: createAction(actionTypes.SET_TABLE_DATA, (data) => ({ data })),
		appendData: createAction(actionTypes.APPEND_TABLE_DATA, (data) => ({ data })),
		resetData: createAction(actionTypes.RESET_TABLE_DATA),
	};

	const selectors = {
		getData: (state) => state[name],
	};

	const tableReducer = {
		[actionTypes.SET_TABLE_DATA]: (state, { payload }) => [...payload.data],
		[actionTypes.APPEND_TABLE_DATA]: (state, { payload }) => state.concat(payload.data),
		[actionTypes.RESET_TABLE_DATA]: () => initialState,
	};

	return {
		actionTypes,
		actions,
		selectors,
		reducer: handleActions(tableReducer, initialState),
	};
};

export const resetOnAcion = (actionName) => (reducer) => (state, action) => {
	if (action.type === actionName) {
		return reducer(undefined, { type: 'OLD_STATE', payload: state });
	}

	return reducer(state, action);
};

const persistStateKeys = [appUser, head(split('.')(configJSON))];
export const resetFetchReducerOnAction = (actionName) => (reducer) => (state, action) => {
	if (action.type === actionName) {
		let newState = {};
		for (const url in state) {
			if (state.hasOwnProperty(url) && includes(url, persistStateKeys)) {
				newState = { ...newState, [url]: state[url] };
			}
		}
		return reducer(newState, { type: 'OLD_STATE', payload: state });
	}

	return reducer(state, action);
};

export const applyAction =
	(action, ...args) =>
	() =>
		action(...args);

export const generateCommonFetchActions = (fetchData, url) => {
	return {
		loadSorted: (sort) => (dispatch, getState) => {
			const { queryParams, ...rest } = fetch.selectors.getLastRequest(url)(getState());
			const requestParams = {
				...rest,
				queryParams: { ...queryParams, sort },
			};
			dispatch(fetchData(requestParams, appendMode.SET));
		},
		loadMore: () => (dispatch, getState) => {
			const { queryParams, ...rest } = fetch.selectors.getLastRequest(url)(getState());
			const requestParams = {
				...rest,
				queryParams: { ...queryParams, page: queryParams.page + 1 },
			};
			dispatch(fetchData(requestParams, appendMode.APPEND));
		},
		loadPage: (page) => (dispatch, getState) => {
			const { queryParams, ...rest } = fetch.selectors.getLastRequest(url)(getState());
			const requestParams = {
				...rest,
				queryParams: { ...queryParams, page },
			};
			dispatch(fetchData(requestParams, appendMode.SET));
		},
		reload: () => (dispatch, getState) => {
			const lastRequest = fetch.selectors.getLastRequest(url)(getState());
			if (isEmpty(lastRequest)) return;
			dispatch(fetchData(lastRequest, appendMode.SET));
		},
	};
};
